import { Injectable } from '@angular/core';
import { BaseService } from '../abstracts/base.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService extends BaseService {

  dashboardData() {
    return this.httpClient.get<any>(this.getApiUrl('dashboards'));
  }
 

}
